<template>
  <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="closePopup">
    <div v-if="centerPopup">
      Ihr Standort
    </div>
    <div v-else-if="marker">
      <div class="store position-relative">
          <store :store="marker" :onMap="true" />
      </div>
    </div>
  </gmap-info-window>
</template>

<script>
import Store from '@/components/Store'

export default {
    name: 'MapPopup',
    components: {
        Store
    },
    props: {
        marker: {
            type: Object
        },
        infoWindowPos: {
            type: Function | null
        },
        infoWinOpen: {
            type: Boolean,
            default: false
        },
        centerPopup: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closePopup () {
            this.$emit('closePopup')
            this.infoWinOpen = false
        }
    },
    data () {
        return {
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            }
        }
    }
}
</script>
